import { useIntl } from "react-intl";

import Badge from "../../ui-components/Badge";

const getBadgeType = (status) => {
  switch (status) {
    case "ACTIVE":
      return "warning";
    case "CLOSED":
      return "primary";
    case "APPROVED":
      return "success";
    default:
    case "OPEN":
      return "info";
  }
};

export const TaskStatusBadge = ({ status }) => {
  const intl = useIntl();

  return (
    <Badge
      type={getBadgeType(status)}
      text={intl.formatMessage({ id: `task_status_${status}` })}
      textSize="text-xs"
    />
  );
};
